export const AVATAR_FULL_SIZE = 1600;
export const AVATAR_THUMB_SIZE = 256;

const ensureCanvasContext = (canvas: HTMLCanvasElement) => {
  const context = canvas.getContext('2d');
  if (!context) {
    throw new Error('Unable to create 2d context');
  }
  return context;
};

const loadImage = (dataUrl: string): Promise<HTMLImageElement> => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error('Failed to load avatar image'));
    image.src = dataUrl;
  });
};

const canvasToBlob = (canvas: HTMLCanvasElement): Promise<Blob> => {
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (!blob) {
        reject(new Error('Failed to create image blob'));
        return;
      }
      resolve(blob);
    }, 'image/png');
  });
};

export const blobToDataUrl = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = () => reject(new Error('Failed to read image blob'));
    reader.readAsDataURL(blob);
  });
};

export const createAvatarThumbnail = async (dataUrl: string, size = AVATAR_THUMB_SIZE): Promise<Blob> => {
  const image = await loadImage(dataUrl);
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const ctx = ensureCanvasContext(canvas);
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, size, size);
  ctx.drawImage(image, 0, 0, size, size);
  return canvasToBlob(canvas);
};

export const createAvatarThumbnailFromBlob = async (blob: Blob, size = AVATAR_THUMB_SIZE): Promise<Blob> => {
  const dataUrl = await blobToDataUrl(blob);
  return createAvatarThumbnail(dataUrl, size);
};

export const createOpaquePngFromBlob = async (
  blob: Blob,
  backgroundColor = '#ffffff'
): Promise<Blob> => {
  const dataUrl = await blobToDataUrl(blob);
  const image = await loadImage(dataUrl);
  const canvas = document.createElement('canvas');
  canvas.width = image.width || AVATAR_FULL_SIZE;
  canvas.height = image.height || AVATAR_FULL_SIZE;
  const ctx = ensureCanvasContext(canvas);
  ctx.fillStyle = backgroundColor;
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
  return canvasToBlob(canvas);
};
